var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import MessageTextSquare02Svg from './message-text-square-02.icon.svg';
export const MessageTextSquare02Icon = (iconInstanceProps) => _jsx(Icon, { ...iconInstanceProps, SvgComponent: MessageTextSquare02Svg });
_react_refresh_temp_1 = MessageTextSquare02Icon;
$RefreshReg$(_react_refresh_temp_1, "MessageTextSquare02Icon");
